import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { ProjectSubjectNamePipe } from '@app/ps/pipes/project-subject-name.pipe';

/**
 *  Název, pokud je vyplněn, jinak jméno a příjmení osoby a identifikačním číslem v závorce.
 */
@Pipe({
  name: 'lesseeSummary',
  pure: false,
})
@Injectable({
  providedIn: 'root'
})
export class LesseeSummaryPipe implements PipeTransform {
  constructor(
    private projectSubjectNamePipe: ProjectSubjectNamePipe,
  ) { }

  transform(lessee: any): string {
    if (!lessee) {
      return '';
    }

    return [
      lessee.companyName || this.projectSubjectNamePipe.transform(lessee, false, false),
      lessee.identificationNumber ? `(IČO ${lessee.identificationNumber})` : '',
    ]
      .map(part => (part || '').trim())
      .filter(part => part)
      .join(" ");
  }
}
